<template>
  <div
    class="absolute top-0 left-0 z-50 flex items-center justify-center w-full h-full"
    :class="[!classes.includes('bg-') && 'bg-ricoma-transparent-300', ...classes]"
  >
    <BounceLoader color="#FC9500" :size="size" sizeUnit="px" />
  </div>
</template>

<script>
import { BounceLoader } from '@saeris/vue-spinners';

export default {
  name: 'VLoader',
  components: { BounceLoader },
  props: {
    classes: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: Number,
      required: false,
      default: 50,
    },
  },
};
</script>
